export default function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_@babel_runtime@7.14.8@@babel/runtime/helpers/esm/isNativeReflectConstruct.js
// module id = 239
// module chunks = 38